<template>
  <v-card class="mb-4 mt-3" color="blue-grey lighten-5" outlined>
    <!-- STEP 1: Context Selection -->
    <div class="mx-4">
      <!-- <h3 class="mb-2">1. Select What You Want To Work On</h3>
        <v-select
          v-model="selectedContext"
          :items="contextOptions"
          label="Select What You Want To Work On"
          outlined
          @change="resetSelection"
        >
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title class="text-wrap">{{ item }}</v-list-item-title>
            </v-list-item-content>
          </template>
        </v-select> -->
      <v-card
        elevation="1"
        flat
        class="pa-4 mb-4"
        style="border-radius: '26px'"
        color="#FAFAFA"
      >
        <v-radio-group v-model="selectedContext" @change="resetSelection">
          <template v-slot:label>
            <h3 class="mb-2">
              1. Selected:
              <v-btn text outlined color="teal" medium
                ><strong>{{ selectedContext }}</strong></v-btn
              >
            </h3>
          </template>
          <v-radio :value="primaryOptionLabel" color="teal">
            <template v-slot:label>
              <div>
                <strong class="success--text text--darken-2">{{
                  primaryOptionLabel
                }}</strong>
              </div>
            </template>
          </v-radio>
          <v-radio :value="clientOptionLabel">
            <template v-slot:label>
              <div>
                <strong class="primary--text">{{ clientOptionLabel }}</strong>
              </div>
            </template>
          </v-radio>
          <v-radio value="Quotations" color="warning">
            <template v-slot:label>
              <div><strong class="warning--text">Quotations</strong></div>
            </template>
          </v-radio>
        </v-radio-group>
      </v-card>
    </div>

    <!-- STEP 2: Item Selection based on chosen Context -->
    <div v-if="selectedContext" class="mt-n4">
      <!-- OPTION A: Primary Industry Entity (Cases / Projects / Job Cards / Files) -->
      <div v-if="selectedContext === primaryOptionLabel">
        <v-card-text>
          <!-- Custom Autocomplete for Legal Cases -->
          <!-- <div v-if="getAppMode === 'legal'">
              <h4 class="mx-4 grey--text text--darken-2">2. Create or Manage {{ primaryOptionLabel }}</h4>
            <v-autocomplete
              v-model="selectedItem"
              :items="formattedCases"
              :label="`Add or Search ${getFileLabel} (Ref / Court No / SAPS No)`"
              prepend-inner-icon="mdi-magnify"
              outlined
              hide-details
              placeholder="Type to search..."
              @change="emitSelection('primary')"
            >
              <template v-slot:prepend-item>
                <v-list-item ripple @click.prevent="$emit('open-add-case-dialog')">
                  <v-list-item-content>
                    <v-list-item-title class="success--text font-weight-bold">
                      <v-btn color="primary" block>
                        <v-icon dark left>mdi-plus-circle</v-icon>Add New {{ fileLabel }}
                      </v-btn>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mb-2"></v-divider>
              </template>
  
              <template v-slot:item="{ item }">
                <v-list-item-content>
                  <v-list-item-title class="text-wrap">
                    {{ item.clientName }}
                    <small class="grey--text d-block">
                      {{ item.internalRef + ' | ' + item.courtCaseNo }}
                    </small>
                  </v-list-item-title>
                </v-list-item-content>
  
                <v-list-item-action class="flex-row">
                  <v-btn icon small color="primary" @click.stop="$emit('open-dialog', 'edit', item)">
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn icon small color="error" @click.stop="$emit('open-dialog', 'delete', item)">
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </template>
            </v-autocomplete>
            </div> -->

          <!-- Standard CRUD Autocomplete for all other industries -->
          <!-- <AutoCompleteCrudAdvanced
              v-else
              class="mx-4"
              :table="primaryTable"
              :label="`Create or Manage ${primaryOptionLabel}`"
              :formatter="fileFormatter"
              @input="handleSelection('primary', $event)"
            /> -->

          <!-- <VirtualScrollCrudAdvanced
              class="mx-4"
              :table="primaryTable"
              :label="`${primaryOptionLabel}`"
              :formatter="fileFormatter"
              @input="handleSelection('primary', $event)"/> -->

          <div>
            <!-- <v-expansion-panels v-model="panelState">
              <v-expansion-panel class="rounded-lg border-grey">
               
                <v-expansion-panel-header class="py-3 px-4 bg-light">
                  <template v-slot:default="{ open }">
                    <div class="d-flex align-center w-100">
                      <div>
                        <div
                          class="text-subtitle-1 font-weight-bold grey--text text--darken-3"
                        >
                          {{ primaryOptionLabel }} Selection
                        </div>
                        <div class="text-caption grey--text text--darken-1">
                          {{ selectedSummary }}
                        </div>
                      </div>

                      <v-spacer></v-spacer>

                      
                      <v-chip
                        x-small
                        label
                        :color="open ? 'success' : 'warning lighten-2'"
                        :text-color="'white'"
                        class="mr-2 font-weight-bold"
                      >
                        {{ open ? "Active" : "Tap to View" }}
                      </v-chip>
                    </div>
                  </template>
                </v-expansion-panel-header>

              
                <v-expansion-panel-content class="pt-2">
                  <VirtualScrollCrudAdvanced
                    :table="primaryTable"
                    :label="`${primaryOptionLabel}`"
                    :formatter="fileFormatter"
                    @input="onHandleSelection('primary', $event)"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels> -->

            <ExpansionPanelWrapper
              :label="`${primaryOptionLabel}`"
              :subLabel="`Create ${primaryOptionLabel} or Manage existing ones`"
              :selectedItem="selectedItem"
              @item-clicked="onHandleSelection"
            >
              <!-- Use the slot scope 'select' callback to bind input events -->
              <template v-slot:content="{ select }">
                <VirtualScrollCrudAdvanced
                  :table="primaryTable"
                  :label="`Manage ${primaryOptionLabel}`"
                  :formatter="fileFormatter"
                  @input="select({ type: 'primary', data: $event })"
                />
              </template>
            </ExpansionPanelWrapper>
          </div>
        </v-card-text>

        <!-- Optional Billing Timer Container -->
        <v-card v-if="selectedItem" class="mx-4 mb-3">
          <v-expansion-panels class="mb-6">
            <v-expansion-panel v-for="(item, i) in 1" :key="i">
              <v-expansion-panel-header expand-icon="mdi-menu-down">
                Click To Open Billing Timer
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <billing-timer
                  @add-to-ledger="(entry) => $emit('add-to-ledger', entry)"
                />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card>
      </div>

      <!-- OPTION B: Clients / Patients / Accounts -->
      <div v-else-if="selectedContext === clientOptionLabel">
        <!-- <v-card class="mt-3" color="blue-grey lighten-5" flat>
          <VirtualScrollCrudAdvanced
            class="mx-4"
            table="clients"
            :label="`${getClientLabel} Accounts`"
            @input="handleSelection('client', $event)"
          />
        </v-card> -->
        <v-card-text>
          <ExpansionPanelWrapper
            :label="`${getClientLabel}s Accounts`"
            :subLabel="`Create ${getClientLabel} or Manage existing ones`"
            :selectedItem="selectedItem"
            @item-clicked="onHandleSelection"
          >
            <!-- Use the slot scope 'select' callback to bind input events -->
            <template v-slot:content="{ select }">
              <VirtualScrollCrudAdvanced
                :table="'clients'"
                :label="`${getClientLabel} Accounts`"
                @input="select({ type: 'client', data: $event })"
              />
            </template>
          </ExpansionPanelWrapper>
        </v-card-text>
      </div>

      <!-- OPTION C: Quotations -->
      <div v-else-if="selectedContext === 'Quotations'">
        <!-- <VirtualScrollCrudAdvanced
          class="mx-4"
          table="quotations"
          label="Quotes"
          :formatter="formatQuotes"
          @input="handleSelection('quote', $event)"
        /> -->
        <v-card-text>
          <ExpansionPanelWrapper
            label="Quotations"
            :subLabel="`Create Estimates or Manage existing ones`"
            :selectedItem="selectedItem"
            @item-clicked="onHandleSelection"
          >
            <!-- Use the slot scope 'select' callback to bind input events -->
            <template v-slot:content="{ select }">
              <VirtualScrollCrudAdvanced
                table="quotations"
                label="Quotes"
                :formatter="formatQuotes"
                @input="select({ type: 'quote', data: $event })"
              />
            </template>
          </ExpansionPanelWrapper>
        </v-card-text>
      </div>
    </div>
  </v-card>
</template>

<script>
import companiesJs from "@/plugins/companies";
import AutoCompleteCrudAdvanced from "@/modules/CrudDatabases/AutoCompleteCrudAdvanced.vue";
import VirtualScrollCrudAdvanced from "@/modules/CrudDatabases/VirtualScrollCrudAdvanced.vue";
import BillingTimer from "@/modules/CaseManager/BillingTimer.vue";
import ExpansionPanelWrapper from "@/components/General/ExpansionPanelWrapper.vue";

export default {
  name: "SelectionPane",
  components: {
    AutoCompleteCrudAdvanced,
    BillingTimer,
    VirtualScrollCrudAdvanced,
    ExpansionPanelWrapper,
  },
  props: {
    formattedCases: {
      type: Array,
      default: () => [],
    },

    fileFormatter: {
      type: Function,
      default: null,
    },
  },
  data: () => ({
    selectedContext: null,
    selectedItem: null,
    tableMap: {
      legal: "legal_cases",
      general: "invoices",
      autoservice: "auto_service_cards",
      projects: "projects",
      events: "events",
      privatePractice: "patient_files",
      social: "social_work_files",
    },
  }),
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getFileLabel() {
      return this.$store.getters.getFileLabel || "File";
    },
    getAppMode() {
      return this.$store.getters.getAppMode || "general";
    },
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
    getClientLabel() {
      return this.$store.getters.getClientLabel || "Client";
    },
    primaryTable() {
      return this.tableMap[this.getAppMode] || "invoices";
    },
    primaryOptionLabel() {
      return this.getFileLabel.endsWith("s")
        ? this.getFileLabel
        : `${this.getFileLabel}s`;
    },
    clientOptionLabel() {
      return `${this.getClientLabel}s Accounts`;
    },
    contextOptions() {
      return [this.primaryOptionLabel, this.clientOptionLabel, "Quotations"];
    },
    selectedSummary() {
      if (this.selectedItem && this.selectedItem.name) {
        return `Selected: ${this.selectedItem.name}`;
      }
      return "Tap to View or Select " + this.primaryOptionLabel;
    },
  },
  watch: {
    async getUserCompany() {
      await this.initialiseDashboard();
    },
  },
  async mounted() {
    await this.initialiseDashboard();
    //this.checkInitialPanelState();
  },
  methods: {
    async initialiseDashboard() {
      this.selectedContext = "Quotations";
      if (!this.getUserCompany) {
        await companiesJs.initialiseCompanyAndLogo();
      }
      this.selectedContext = this.primaryOptionLabel;
    },
    resetSelection() {
      this.selectedItem = null;
      this.$emit("context-changed", this.selectedContext);
    },
    handleSelection(category, item) {
      this.selectedItem = item;
      this.emitSelection(category);
    },
    formatQuotes({ quotes }) {
      if (!quotes || !quotes.length) return [];
      const quotations = [];

      quotes.forEach((quote) => {
        quotations.push({
          ...quote,
          name: `${quote.client?.name} | ${quote.quote_number}`,
        });
      });
      //this.quotations = quotations
      return quotations;
    },
    emitSelection(category) {
      // Emits payload with category type, raw object, and contextual industry labels
      this.$emit("selected", {
        category, // 'primary' | 'client' | 'quote'
        context: this.selectedContext,
        industry: this.getAppMode,
        fileLabel: this.getFileLabel,
        getClientLabel: this.getClientLabel,
        data: this.selectedItem,
      });
    },
    onHandleSelection(payload) {
      // payload will be: { type: 'primary', data: $event }
      const event = payload.data;
      const type = payload.type;

      this.selectedItem = event;

      // 1. Call your existing selection logic
      this.handleSelection(type, event);
    },
  },
};
</script>

<style scoped>
.border-grey {
  border: 1px solid #e0e0e0 !important;
}

.bg-light {
  background-color: #f8f9fa !important;
}

.custom-panel .v-expansion-panel-header {
  min-height: 64px;
}
</style>
